<template>
  <canvas
    style="border: 1px solid rgba(0, 0, 0, 0.12); width: 100%; height: 100%"
    ref="canvas"
    @mousedown="mouseDown"
    @mousemove="mouseMove"
    @mouseup="mouseUp"
    @mouseleave="mouseUp"
    @touchstart="touchStart"
    @touchmove="touchMove"
    @touchend="touchEnd"
  />
</template>
<script>
export default {
  name: 'AppDrawableArea',
  props: ['value', 'disable'],
  data() {
    return {
      x: 0,
      y: 0,
      isDrawing: false,
      canvas: null
    };
  },
  watch: {
    value(newVal) {
      if (!newVal) {
        this.handleClear();
      }
      // this.load(newVal);
    }
  },
  methods: {
    load(data) {
      if (!data) {
        this.handleClear();
      } else {
        const img = new Image();
        img.onload = () => {
          this.ctx.drawImage(
            img,
            0,
            0,
            img.width,
            img.height,
            0,
            0,
            this.$refs.canvas.offsetWidth,
            this.$refs.canvas.offsetHeight
          );
        };
        img.src = data;
      }
    },
    drawLine(x1, y1, x2, y2) {
      const { ctx } = this;
      ctx.strokeStyle = 'black';
      ctx.lineWidth = 2;
      ctx.lineJoin = 'round';
      ctx.lineCap = 'round';
      ctx.beginPath();
      ctx.moveTo(x1, y1);
      ctx.lineTo(x2, y2);
      ctx.stroke();
      ctx.closePath();
    },
    mouseDown(e) {
      if (this.disable) return;
      this.x = e.offsetX;
      this.y = e.offsetY;
      this.isDrawing = true;
    },
    mouseMove(e) {
      if (this.disable) return;
      if (this.isDrawing === true) {
        this.drawLine(this.x, this.y, e.offsetX, e.offsetY);
        this.x = e.offsetX;
        this.y = e.offsetY;
      }
    },
    mouseUp(e) {
      if (this.disable) return;
      if (this.isDrawing === true) {
        this.drawLine(this.x, this.y, e.offsetX, e.offsetY);
        this.x = 0;
        this.y = 0;
        this.isDrawing = false;
        this.$emit('input', this.ctx.canvas.toDataURL());
      }
    },
    touchStart(e) {
      if (this.disable) return;
      const touchPos = this.getTouchPos(this.canvas, e);
      console.log(this.x, this.y);
      this.x = touchPos.x;
      this.y = touchPos.y;
      this.isDrawing = true;
    },
    touchMove(e) {
      if (this.disable) return;
      if (this.isDrawing === true) {
        const touchPos = this.getTouchPos(this.canvas, e);
        this.drawLine(this.x, this.y, touchPos.x, touchPos.y);
        this.x = touchPos.x;
        this.y = touchPos.y;
      }
    },
    touchEnd() {
      if (this.disable) return;
      if (this.isDrawing === true) {
        this.x = 0;
        this.y = 0;
        this.isDrawing = false;
        this.$emit('input', this.ctx.canvas.toDataURL());
      }
    },
    getTouchPos(canvasDom, touchEvent) {
      const rect = canvasDom.getBoundingClientRect();
      return {
        x: touchEvent.touches[0].clientX - rect.left,
        y: touchEvent.touches[0].clientY - rect.top
      };
    },
    handleClear() {
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
      this.ctx.beginPath();
    }
  },
  mounted() {
    this.canvas = this.$refs.canvas;
    this.ctx = this.canvas.getContext('2d');
    this.$refs.canvas.width = this.$refs.canvas.offsetWidth;
    this.$refs.canvas.height = this.$refs.canvas.offsetHeight;
    this.load(this.value);

    this.canvas.addEventListener('touchstart', (e) => {
        e.preventDefault();
    }, false);
    this.canvas.addEventListener('touchend', (e) => {
      e.preventDefault();
    }, false);
    this.canvas.addEventListener('touchmove', (e) => {
      e.preventDefault();
    }, false);
  }
};
</script>
